//用于自由绘制隔墙时,结束时使用
let overButton = null;
//点击结束按钮状态
let clickOverButtonType = false;
import store from "@/store";
import { eraseOtherData } from "@/rlMxModules/operate/inputElement.js";
//获取结束按钮
export const getOverButton = () => {
  return overButton;
};

//创建结束按钮
export const createOverButton = () => {
  overButton = document.createElement("button");

  // 添加一个特殊的类名，方便在开发者工具中找到它
  overButton.className = "rl-over-button";

  // 设置基本属性
  overButton.innerHTML = "结束";
  overButton.style.cssText = `
    position: fixed !important;
    top: 50px !important;
    right: 50px !important;
    z-index: 99999 !important;
    width: 40px !important;
    height: 40px !important;
    border: 2px solid rgba(117, 193, 196, 0.6) !important;
    background: rgba(255, 255, 255, 0.8) !important;
    cursor: pointer !important;
    border-radius: 50% !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
    color: #000 !important;
    font-family: Arial, sans-serif !important;
    font-size: 14px !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    opacity: 0.8 !important;
    visibility: visible !important;
    transition: all 0.3s ease !important;
    user-select: none !important;
    -webkit-tap-highlight-color: transparent !important;
    touch-action: manipulation !important;
    pointer-events: auto !important;
    backdrop-filter: blur(2px) !important;
  `;

  //当移动端点击弹起后触发
  overButton.addEventListener("touchend", (e) => {
    // 先执行按钮自身的逻辑
    clickOverButtonType = true;

    // 临时禁用按钮的指针事件，允许事件穿透
    // overButton.style.pointerEvents = "none";

    // 手动触发一次 setUserDraw 的回调
    const touch = e.changedTouches[0];
    const screenX = touch.clientX;
    const screenY = touch.clientY;

    // 获取CAD画布
    const canvas = document.querySelector("canvas");
    if (canvas) {
      // 转换为CAD坐标
      const rect = canvas.getBoundingClientRect();
      // 先转换为文档坐标
      const docPoint = rlAppObj._rlMx.MxFun.screenCoord2Doc(
        screenX - rect.left,
        screenY - rect.top
      );
      // 再转换为CAD坐标
      const cadPoint = rlAppObj._rlMx.MxFun.docCoord2Cad(
        docPoint.x,
        docPoint.y
      );

      // 手动触发 setUserDraw 的回调

      if (window.currentSetUserDrawCallback) {
        window.currentSetUserDrawCallback({
          x: cadPoint.x,
          y: cadPoint.y,
        });
      }
    }
  });

  overButton.addEventListener("click", () => {
    clickOverButton();
  });

  // 添加到body前先检查body是否存在
  if (document.body) {
    document.body.appendChild(overButton);
  }
  return overButton;
};

//点击事件
export const clickOverButton = () => {
  // rlAppObj._rlMx.MxFun.stopRunCommand();
  clickOverButtonType = true;
  if (!store.state.app.isPcMode) {
    window.currentSetUserDrawCallback = null;
    store.commit("drawModules/setDrawPlay", false); // 设置绘制状态为结束
    eraseOtherData();
    destroyOverButton();
  }
};

//获取点击结束按钮的状态
export const getClickOverButtonType = () => {
  return clickOverButtonType;
};

//销毁结束按钮
export const destroyOverButton = async () => {
  if (overButton) {
    await overButton.remove();
    overButton = null;
  }
  clickOverButtonType = false;
};

//修改按钮位置
export const setOverButtonPosition = (x, y) => {
  if (!overButton) {
    return;
  }
  // 坐标转换
  const selectObjPoint = rlAppObj._rlMx.MxFun.cadCoord2Doc(x, y);
  // 将文档坐标转换为屏幕坐标
  const pxPoint = rlAppObj._rlMx.MxFun.docCoord2Screen(
    selectObjPoint.x,
    selectObjPoint.y
  );
  overButton.style.left = pxPoint.x + "px";
  overButton.style.top = pxPoint.y + "px";
};
